export const ACTION_ADD_AFFILIATED_WEBMASTERS = 'ACTION_ADD_AFFILIATED_WEBMASTERS';
